import React from 'react';
import { Navigate, Route, BrowserRouter as Router, Routes } from "react-router-dom";

import WebApp from './web-app.js'
import './App.css';


import Main from "./client/components/main/main";
import ContactUs from './client/components/contactUs/contactUs';
import OurServices from './client/components/services/ourServices/ourServices.js';
import OurPortfolio from './client/components/ourPortfolio/ourPortfolio.js';
import PortfolioExample from './client/components/portfolioExamplePage/portfolioExample.js';
import PrivacyPolicy from './client/components/PrivacyPolicy/PrivacyPolicy.js';
import AboutUs from './client/components/About/AboutUs.js';
import ScrollToTop from "./client/components/utils/ScrollToTop";
import TermsOfService from "./client/components/Terms/TermsOfService";
import CookiePolicy from './client/components/CookiePolicy/CookiePolicy.js';
import Accessibility from './client/components/Accessibility/Accessibility.js';
import Pricetags from './client/components/Pricetags/Pricetags.jsx';

import Page404 from "./client/components/errorBoundary/Page404.js";
import AppErrorBoundaryWrapper from './client/components/errorBoundary/ErrorBoundary.js';

// ⭐ ДОБАВИЛИ PERFORMANCE ENGINE
import PerformanceProvider from './performance/PerformanceProvider';

function App() {
  return (
    <PerformanceProvider>
      <Router>
        <div className="App">

          <ScrollToTop />

          <Routes>

            <Route path="/" element={<WebApp />}>
              <Route index element={<Navigate to="home" replace />} />

              <Route element={<AppErrorBoundaryWrapper />}>
                <Route path="home" element={<Main />} />
                <Route path="contactUs" element={<ContactUs />} />
                <Route path="/ourservices/:id" element={<OurServices />} />
                <Route path="/portfolio/:id" element={<PortfolioExample />} />
                <Route path="ourPortfolio" element={<OurPortfolio />} />
                <Route path="privacyPolicy" element={<PrivacyPolicy />} />
                <Route path="about" element={<AboutUs />} />
                <Route path="terms-of-service" element={<TermsOfService />} />
                <Route path="cookiePolicy" element={<CookiePolicy />} />
                <Route path="accessibility" element={<Accessibility />} />
                <Route path="pricetags" element={<Pricetags />} />
                
              </Route>

              <Route path="*" element={<Page404 />} />
            </Route>

          </Routes>
        </div>
      </Router>
    </PerformanceProvider>
  );
}

export default App;